import { appConfig } from '@/config'

export const ceilingMultiplier = (value: bigint, type: 'buy' | 'sell') => {
  const ceilingMultiplier = BigInt(Math.round(appConfig.ceiling * 100))
  const percentage = (value * ceilingMultiplier) / 100n

  return type === 'buy' ? value + percentage : value - percentage
}
